
  if(typeof get_sc_preorder_global=='undefined'){
    function get_sc_preorder_global(init_params){

      var sc_preorder_global = {

        selectors:{
          preorder_box_placeholders:[
              {position: 'after', selector: '.product-form'},
              {position: 'before', selector: '.product-single__description'},
              {position: 'after', selector: '.product-form__item--submit'},
              {position: 'after', selector: '.product-form__item'}
          ]
        },

        store_selectors:{
          store_preorder_box_placeholder: {position: '', selector: ''}
        },

        
        
        
        is_valid_customer_preorder_group: function(plan_group){
          if(this.sc_app_preorder_logged_in_customer==null){
            return false;
          }
          else{
            if(this.sc_app_preorder_logged_in_customer.tags==null){
              return false;
            }
            var k=0;
            for(k=0;k < this.sc_app_preorder_logged_in_customer.tags.length;k++){
              if(this.sc_app_preorder_rules[plan_group.app_id].data.rule.customer_tags.includes(this.sc_app_preorder_logged_in_customer.tags[k])){
                return true;
              }
            }
            return false;
          }
        },

        is_valid_preorder_group_for_product: function(product,plan_group){
          var prule=this.sc_app_preorder_rules[plan_group.app_id].data;
          console.log('prule',prule);

          if(prule.status!='1'){
            return false;
          }
          
          var has_any_varaint_stock_status_matched=false;
          if(prule.rule.show_pre_order=='any'){
            has_any_varaint_stock_status_matched=true;
          }
          else{
            var i=0;
            for(i=0;i< product.variants.length;i++){
              //console.log(product.variants[i].stock_status +'=='+ prule.rule.show_pre_order)
              if(product.variants[i].stock_status == prule.rule.show_pre_order){
                has_any_varaint_stock_status_matched=true;
                break;
              }
            }
          }
          
          if(!has_any_varaint_stock_status_matched){
            console.log('does not match');
            return false;
          }

          if(prule.rule.available_status=='not_available'){
            return false;
          }
          else{
            if(prule.rule.available_status=='schedule'){
              //Start and end date checking
              var today=new Date().setHours(0, 0, 0, 0);
              //console.log('today',today);
              if(prule.rule.available_start_date!=''){
                //console.log('start date',new Date(prule.rule.available_start_date).setHours(0, 0, 0, 0));
                if(today < new Date(prule.rule.available_start_date).setHours(0, 0, 0, 0)){
                  return false;
                }
              }
              if(prule.rule.available_end_date!=''){
                if(today > new Date(prule.rule.available_end_date).setHours(0, 0, 0, 0)){
                  return false;
                }
              }
            }
          }

          return true;

        },

        is_valid_preorder_group_for_variant: function(variant,plan_group){
          var prule=this.sc_app_preorder_rules[plan_group.app_id].data;
          
          if(prule.rule.show_pre_order=='any'){
            return true;
          }

          if(variant.stock_status == prule.rule.show_pre_order){
            return true;
          }

          return false;

        },

        get_product_preorder_group: function(product){
          var selling_plan_groups=product.selling_plan_groups;
          console.log('selling_plan_groups',selling_plan_groups);
          var arr_groups=[];
          var i=0;
          for(i=0; i < selling_plan_groups.length;i++){
            //console.log(selling_plan_groups[i]);
            if(this.sc_app_preorder_rules.hasOwnProperty(selling_plan_groups[i].app_id)){
              //console.log('selling_plan_groups[i]',selling_plan_groups[i]);
              if(this.is_valid_preorder_group_for_product(product,selling_plan_groups[i])){
                //console.log('updated: '+sc_app_preorder_rules[selling_plan_groups[i].app_id].data.updated_at);
                arr_groups.push(selling_plan_groups[i]);
              }
            }
          }
          console.log(arr_groups);
          if(arr_groups.length==0){
            return null;
          }
          if(arr_groups.length==1){
            var plan_group = arr_groups[0];

            var ctags=this.sc_app_preorder_rules[plan_group.app_id].data.rule.customer_tags ?? [];
            if(ctags.length > 0){
              //console.log('is valid customer',this.is_valid_customer_preorder_group(plan_group));
              if(this.is_valid_customer_preorder_group(plan_group)){
                return plan_group;
              }
              else{
                return null;
              }
            }
            else{
              return plan_group;
            }


            
          }

          if(arr_groups.length > 1){
            console.log("GROUPS 2");
            var customer_group=null;
            var regular_group=null;
            var k=0;
            for(k=0;k < arr_groups.length; k++){
              var ctags=this.sc_app_preorder_rules[arr_groups[k].app_id].data.rule.customer_tags ?? [];
              if(ctags.length > 0){
                if(this.is_valid_customer_preorder_group(arr_groups[k])){
                  if(customer_group!=null){
                    if(this.sc_app_preorder_rules[arr_groups[k].app_id].data.updated_at > this.sc_app_preorder_rules[customer_group.app_id].data.updated_at){
                      customer_group=arr_groups[k];
                    }
                  }
                  else{
                    customer_group=arr_groups[k];
                  }
                }
              }
              
              if(customer_group==null){
                if(ctags.length==0){
                  console.log('REGULAR');
                  if(regular_group!=null){
                    if(this.sc_app_preorder_rules[arr_groups[k].app_id].data.updated_at > this.sc_app_preorder_rules[regular_group.app_id].data.updated_at){
                      regular_group=arr_groups[k];
                    }
                  }
                  else{
                    regular_group=arr_groups[k];
                  }
                }
                
              }
            }

            if(customer_group!=null){
              return customer_group;
            }
            else{
              return regular_group;
            }
          }
        },

        preorder_process_product_page: function(){
          this.auto_set_grid_placeholder();
            var preorder_box_product_page_selector='#div-sc-preorder-2017210342';
            var product_page_add_to_cart_form_selector='form[action="/cart/add"]';


            this.ScJQuery_Preorder(preorder_box_product_page_selector+' .po-widget').remove();

            var selling_plan_group=this.get_product_preorder_group(this.sc_app_preorder_curr_product);
            

            console.log('selling_plan_group',selling_plan_group);
            if(selling_plan_group!=null){

              if(!this.is_valid_preorder_group_for_variant(this.sc_app_preorder_selected_variant,selling_plan_group)){
                return false;
              }

              var tpl = __sc__.template(this.ScJQuery_Preorder(this.get_template_id('#tpl_btn_pre_order')).html());
              this.ScJQuery_Preorder(preorder_box_product_page_selector).append(tpl({'selling_plan_group':selling_plan_group,_self:this}));

              var self_selected_variant=this.sc_app_preorder_selected_variant;
              var self_ScJQuery_Preorder=this.ScJQuery_Preorder;



              this.ScJQuery_Preorder('.sc-preorder-btn').on('click',function(){
                  var elm_form_to_submit=null;
                  var selling_plan_id=self_ScJQuery_Preorder('[name="sc_purchase_option"]:checked').attr('data-selling-plan-id');
                  if(selling_plan_id){
                    self_ScJQuery_Preorder('[name="id"][value="'+self_selected_variant.id+'"]').each(function(index, elm) {
                      if(self_ScJQuery_Preorder(elm).parent().find('[name="selling_plan"]').length == 0){
                        self_ScJQuery_Preorder(elm).parent().append('<input type="hidden" name="selling_plan" value="'+selling_plan_id+'" />');
                      }
                      else{
                        self_ScJQuery_Preorder(elm).parent().find('[name="selling_plan"]').val(selling_plan_id);
                      }

                      if(self_ScJQuery_Preorder(elm).parent().find('[name="quantity"][type="number"]').length > 0){
                        elm_form_to_submit=elm;
                      }
                    });

                    //console.log(elm_form_to_submit);

                    if(elm_form_to_submit==null){
                      self_ScJQuery_Preorder('[name="selling_plan"][value="'+selling_plan_id+'"]').closest('form').submit();
                      return true;
                    }
                    else{
                      self_ScJQuery_Preorder(elm_form_to_submit).closest('form').submit();
                      return true;
                    }


                    
                  }
                  else{
                    self_ScJQuery_Preorder('[name="id"][value="'+self_selected_variant.id+'"]').parents().each(function(index, elm) {
                      self_ScJQuery_Preorder(elm).find('[name="selling_plan"]').val('');
                    });
                  }
                  //this.closest('form').submit();

                  //console.log(product_page_add_to_cart_form_selector);
                  //this.ScJQuery_Preorder(product_page_add_to_cart_form_selector).submit();
              });
            }

          
          

        },

    


        set_variant_select_event: function() {    
          //console.log("hello");
          var _self=this;
          var ddl_ps='body';
          var v_selector='';
          if(this.store_variant_select_selector!=null && this.store_variant_select_selector!=''){
              v_selector=this.store_variant_select_selector;
              this.ScJQuery_Preorder(ddl_ps).on('change',v_selector, this.variant_select_action);
          }
          else{
              v_selector=this.variant_select_selectors.join(', ');
              this.ScJQuery_Preorder(ddl_ps).on('change',v_selector, this.variant_select_action);
          }
          
          //console.log(v_selector);
          if(!this.ScJQuery_Preorder(v_selector).is(':visible')){      
            this.bind_variant_change_on_url_event(function(vid){
              _self.variant_select_action();
            });
          }
              
        },

        bind_variant_change_on_url_event: function(callback) {
          var tmp_url = new URL(window.location.href);    
          var prev_variant_id=tmp_url.searchParams.get('variant');
          setInterval(function(){
              var url = new URL(window.location.href);
              if (url.searchParams.get('variant') != null) {
                  var curr_variant_id=url.searchParams.get('variant');
                if(curr_variant_id!=prev_variant_id){
                  callback(curr_variant_id);
                  prev_variant_id=curr_variant_id;
                }
              }
          },1000);
        },

        variant_select_action: function(){
          url = new URL(window.location.href);
          if (url.searchParams.get('variant') != null) {
              this.SC_QB_On_Variant_Select(url.searchParams.get('variant'));
              return false;
          }
        },

        SC_QB_On_Variant_Select: function(selected_variant_id){
          this.sc_app_preorder_selected_variant=this.get_variant_by_id(selected_variant_id);
          this.preorder_process_product_page();
        },
        get_variant_by_id: function(variant_id){
            var i=0;
            for(i=0;i<this.sc_app_preorder_curr_product.variants.length;i++){
                if(this.sc_app_preorder_curr_product.variants[i].id==variant_id){
                    return this.sc_app_preorder_curr_product.variants[i];
                }
            }
        },

        /*format_money: function (cents) {
          if(typeof Shopify.formatMoney == 'function'){
            return Shopify.formatMoney(
                cents,
                this.money_with_currency_format
            );
          }
          else{
            var amount=parseFloat(parseFloat(cents)/100);
            return new Intl.NumberFormat(navigator.language, {
                style: 'currency',
                currency: this.shop_currency
            }).format(amount);

          }
          
        },*/


        format_money: function(cents, format) {
          //return parseFloat(cents/100);
if (typeof cents == 'string') {
cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /{{\s*(\w+)\s*}}/;
var formatString = (format || this.money_format);
function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
}
function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
        return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
}
switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
    case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
    case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
}
return formatString.replace(placeholderRegex, value);
},


        get_current_currency_rate: function(){
          if(typeof Shopify != 'undefined'){
              if(Shopify.hasOwnProperty('currency')){
                  if(Shopify.currency.hasOwnProperty('rate')){
                      return Shopify.currency.rate;
                  }
              }
          }
          return 1;
        },
        convert_current_currency_value: function(value){
          value=parseFloat(value);
          var currency_rate=parseFloat(this.get_current_currency_rate());
          return currency_rate*value;
        },
        convert_format_current_currency_value: function(value){
          value=(value !== '') ?  value : '0';
          return this.format_money(this.convert_current_currency_value(value));
        },


        auto_set_grid_placeholder: function(){
            if(this.ScJQuery_Preorder('#div-sc-preorder-2017210342').length > 0){
                return;
            }
            var plc_html='<div id="div-sc-preorder-2017210342"></div>';
            
            if(this.store_selectors.preorder_box_placeholder!==null && typeof this.store_selectors.preorder_box_placeholder ==='object'){
                if(this.store_selectors.preorder_box_placeholder.hasOwnProperty('position') && this.store_selectors.preorder_box_placeholder.hasOwnProperty('selector')){
                    if(this.ScJQuery_Preorder(this.store_selectors.preorder_box_placeholder.selector).length > 0){
                        if(this.store_selectors.preorder_box_placeholder.position=='after'){
                            this.ScJQuery_Preorder(this.store_selectors.preorder_box_placeholder.selector).after(plc_html);
                        }
                        else if(this.store_selectors.preorder_box_placeholder.position=='before'){
                            this.ScJQuery_Preorder(this.store_selectors.preorder_box_placeholder.selector).before(plc_html);
                        }
                        else if(this.store_selectors.preorder_box_placeholder.position=='append'){
                            this.ScJQuery_Preorder(this.store_selectors.preorder_box_placeholder.selector).append(plc_html);
                        }
                        
                        return;
                    }
                }        
            }
            
            if(this.ScJQuery_Preorder('#div-sc-preorder-2017210342').length == 0){
                for(i=0;i<this.selectors.preorder_box_placeholders.length;i++){            
                    if(this.ScJQuery_Preorder(this.selectors.preorder_box_placeholders[i].selector).length > 0){
                        if(this.selectors.preorder_box_placeholders[i].position=='after'){
                            this.ScJQuery_Preorder(this.selectors.preorder_box_placeholders[i].selector).after(plc_html);
                        }
                        else if(this.selectors.preorder_box_placeholders[i].position=='before'){
                            this.ScJQuery_Preorder(this.selectors.preorder_box_placeholders[i].selector).before(plc_html);
                        }
                        else if(this.selectors.preorder_box_placeholders[i].position=='append'){
                            this.ScJQuery_Preorder(this.selectors.preorder_box_placeholders[i].selector).append(plc_html);
                        }
                        break;
                    }
                }
                
                if(this.ScJQuery_Preorder('#div-sc-preorder-2017210342').length == 0){
                    if(this.ScJQuery_Preorder("form[action='/cart/add']").length > 0){
                        this.ScJQuery_Preorder("form[action='/cart/add']").after(plc_html);
                    }
                }

            }
        },


        get_template_id: function(tpl_id){
            var suffix='__custom_template';
            if(this.ScJQuery_Preorder(tpl_id+suffix).length > 0){
                return tpl_id+suffix;
            }
            return tpl_id;
        },

        init_templates: function(){
          var tpl_btn_pre_order = document.createElement('script');
          tpl_btn_pre_order.type = 'text/template';
          tpl_btn_pre_order.id = 'tpl_btn_pre_order';
          tpl_btn_pre_order.textContent =`
          <div class="po-widget">
            <% for(var i=0; i < selling_plan_group.selling_plans.length; i++){ %>
              <% if(selling_plan_group.selling_plans[i].options[0]?.value=='Partial Payment'){ 
                var str_deposit_value_partial='';
                if(selling_plan_group.selling_plans[i].checkout_charge.value_type=='percentage'){
                  str_deposit_value_partial=selling_plan_group.selling_plans[i].checkout_charge.value+'%';
                }
                else{
                  str_deposit_value_partial=_self.format_money(selling_plan_group.selling_plans[i].checkout_charge.value);
                }

                var str_discount_value_partial='';
                if(selling_plan_group.selling_plans[i].price_adjustments[0]?.value_type=='percentage'){
                  str_discount_value_partial=selling_plan_group.selling_plans[i].price_adjustments[0]?.value+'%';
                }
                else if(selling_plan_group.selling_plans[i].price_adjustments[0]?.value_type=='fixed_amount'){                
                  str_discount_value_partial=_self.format_money(selling_plan_group.selling_plans[i].price_adjustments[0]?.value);
                }
                %>
            <div class="po-option po-option-active">
                <label class="po-label">
                    <input
                        type="radio"
                        name="sc_purchase_option"
                        value="preorder_partial"
                        data-selling-plan-id="<%=selling_plan_group.selling_plans[i].id%>"
                        checked
                    >
                    <span class="po-radio"></span>

                    <div class="po-content">
                        <div class="po-header">
                            <span class="po-title"><%=(selling_plan_group.selling_plans[i].name ?? '').replaceAll('[[deposit_value]]',str_deposit_value_partial).replaceAll('[[discount_value]]',str_discount_value_partial) %></span>
                            <span class="po-badge">Save <%= str_discount_value_partial %></span>
                        </div>

                        <div class="po-description">
                            <%=(selling_plan_group.selling_plans[i].description ?? '').replaceAll('[[deposit_value]]',str_deposit_value_partial).replaceAll('[[discount_value]]',str_discount_value_partial) %>
                        </div>
                    </div>
                </label>
            </div>
              <% } %>
              <% if(selling_plan_group.selling_plans[i].options[0]?.value=='Full Payment'){ 
                var str_discount_value_full='';
                if(selling_plan_group.selling_plans[i].price_adjustments[0]?.value_type=='percentage'){
                  str_discount_value_full=selling_plan_group.selling_plans[i].price_adjustments[0]?.value+'%';
                }
                else if(selling_plan_group.selling_plans[i].price_adjustments[0]?.value_type=='fixed_amount'){
                  str_discount_value_full=_self.format_money(selling_plan_group.selling_plans[i].price_adjustments[0]?.value);
                }
                %>
            <div class="po-option">
                <label class="po-label">
                    <input
                        type="radio"
                        name="sc_purchase_option"
                        value="preorder_full"
                        data-selling-plan-id="<%=selling_plan_group.selling_plans[i].id%>"
                        checked
                    >
                    <span class="po-radio"></span>

                    <div class="po-content">
                        <div class="po-header">
                            <span class="po-title"><%=(selling_plan_group.selling_plans[i].name ?? '').replaceAll('[[discount_value]]',str_discount_value_full) %></span>
                            <span class="po-badge">Save <%=str_discount_value_full%></span>
                        </div>

                        <div class="po-description">
                            <%=(selling_plan_group.selling_plans[i].description ?? '').replaceAll('[[discount_value]]',str_discount_value_full) %>
                        </div>
                    </div>
                </label>
            </div>
              <% } %>
            <% } %>
            <button type="button" class="button po-button sc-preorder-btn">
                Preorder
            </button>
        </div>

        <style type="text/css">
          .po-widget {
            width: 100%;
            max-width: 420px;
            font-family: inherit;
            padding-top:10px;
            padding-bottom:10px;
        }

        .po-option {
            border: 1px solid #d9d9d9;
            border-bottom: none;
            background: #fff;
        }

        .po-option:first-child {
            border-radius: 8px 8px 0 0;
        }

        .po-option:last-of-type {
            border-bottom: 1px solid #d9d9d9;
            border-radius: 0 0 8px 8px;
        }

        .po-label {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 16px;
            cursor: pointer;
            margin: 0;
        }

        .po-label input[type="radio"] {
            position: absolute;
            opacity: 0;
            pointer-events: none;
        }

        .po-radio {
            width: 16px;
            height: 16px;
            border: 1.5px solid #999;
            border-radius: 50%;
            flex-shrink: 0;
            margin-top: 3px;
            position: relative;
        }

        .po-label input[type="radio"]:checked + .po-radio::after {
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #222;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .po-content {
            flex: 1;
        }

        .po-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
        }

        .po-title {
            font-size: 14px;
            line-height: 1.3;
            font-weight: 500;
            color: #222;
        }

        .po-badge {
            background: #eceaea;
            color: #444;
            font-size: 11px;
            line-height: 1;
            padding: 6px 12px;
            border-radius: 999px;
            white-space: nowrap;
        }

        .po-description {
            /*margin-top: 10px;*/
            color: #444;
            font-size: 14px;
            line-height: 1.5;
        }

        .po-button {
            width: 100%;
            margin-top: 10px;
            /*height: 56px;
            border: 2px solid #111;
            border-radius: 6px;
            background: #fff;
            color: #111;
            font-size: 28px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;*/
        }

        /*.po-button:hover {
            background: #111;
            color: #fff;
        }*/

        @media (max-width: 480px) {
            .po-title {
                font-size: 14px;
            }

            .po-description {
                font-size: 14px;
            }

            /*.po-button {
                font-size: 22px;
                height: 52px;
            }*/
        }
          </style>
        `;
        
          this.ScJQuery_Preorder('body').append(tpl_btn_pre_order);
        },

        init: function(params){
          //this.ScJQuery_Preorder=params.ScJQuery_Preorder;
          for(var prop in params){
            this[prop]=params[prop];
          }
          this.init_templates();
          if(this.current_page=='product'){
            this.set_variant_select_event();
          }
        },





      };

      var tmp_init_sc_preorder_global=init_sc_preorder_global();
      for(var prop in tmp_init_sc_preorder_global){
        sc_preorder_global[prop]=tmp_init_sc_preorder_global[prop];
      }
      sc_preorder_global.init(init_params);

      return sc_preorder_global;

    }
  }

  
